module.exports = {"130123001":"诸福屯街道","130123002":"三里屯街道","130123100":"正定镇","130123102":"新城铺镇","130123103":"新安镇","130123200":"南牛乡","130123201":"南楼乡","130123202":"西平乐乡","130123203":"北早现乡","130123204":"曲阳桥乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130123.json
// module id = 66
// module chunks = 0